import { define, type, auto, Record } from 'type-r'
import Base from './base'

@define
export default class HandicappingModel extends Base {
    
}
